import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    ErrorStatusTypes,
    ErrorsStack,
    parseErrorMessage,
} from "components/common/errorsDeclarations";
import * as operatoriApi from "api/personale/operatoriApi";

// ============================================
// INTERFACES
// ============================================

export interface Operatore {
    id?: number;
    codice?: string;
    nominativo?: string;
    raggruppamanto?: string;
    reparto?: number;
    reparto_display?: string;
    attivo?: boolean;
}

export interface OperatoriList {
    count: number;
    page: number;
    num_pages: number;
    next?: string;
    previous?: string;
    results: Operatore[];
    errorsStack: ErrorsStack;
}

// ============================================
// STATO SLICE
// ============================================

export interface OperatoriState {
    operatoriList: OperatoriList;
}

const initialState: OperatoriState = {
    operatoriList: {
        count: 0,
        page: 0,
        num_pages: 0,
        next: undefined,
        previous: undefined,
        results: [],
        errorsStack: { status: ErrorStatusTypes.OK },
    },
};

// ============================================
// ASYNC THUNKS
// ============================================

export const fetchOperatori = createAsyncThunk(
    "operatori/fetchOperatori",
    async () => {
        return await operatoriApi.fetchOperatori();
    }
);

// ============================================
// SLICE
// ============================================

export const operatoriSlice = createSlice({
    name: "operatori",
    initialState,
    reducers: {
        resetOperatori: (state) => {
            state.operatoriList = initialState.operatoriList;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOperatori.pending, (state) => {
            state.operatoriList.errorsStack = { status: ErrorStatusTypes.PENDING };
        });
        builder.addCase(fetchOperatori.fulfilled, (state, action) => {
            state.operatoriList = action.payload;
            state.operatoriList.errorsStack = { status: ErrorStatusTypes.OK };
        });
        builder.addCase(fetchOperatori.rejected, (state, action) => {
            state.operatoriList.errorsStack = parseErrorMessage(action.error);
        });
    },
});

// ============================================
// EXPORTS
// ============================================

export const { resetOperatori } = operatoriSlice.actions;

export const operatoriSliceReducer = operatoriSlice.reducer;
